import HeroSection from './HeroSection';
import ContactInfoSection from './ContactInfoSection';
import SocialLinksSection from './SocialLinksSection';
import LocationSection from './LocationSection';

const Contact = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <ContactInfoSection />
      <SocialLinksSection />
      <LocationSection />
    </div>
  );
};

export default Contact;
